// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__LVHRH","ThumbZoom":"ChapterPlayer_ThumbZoom__2p0Zg"};